import { ArrowUp } from "lucide-react";
import { LogoMark, Wordmark } from "./Logo";

export const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-bone/10 bg-[#141311] py-14 text-bone">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-5 sm:px-8 md:flex-row md:items-end md:justify-between">
      <div>
        <a href="#top" data-testid="footer-logo-link" className="flex items-center gap-3">
          <LogoMark size={34} dark />
          <Wordmark dark />
        </a>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-bone/50">
          Architectural gastronomy &amp; private catering — weddings, estates
          and boardrooms.
        </p>
      </div>

      <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer">
        {[
          { label: "Menus", href: "#menus" },
          { label: "Services", href: "#services" },
          { label: "Philosophy", href: "#philosophy" },
          { label: "The Chef", href: "#chef" },
          { label: "Gallery", href: "#gallery" },
        ].map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            className="font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60 transition-colors duration-300 hover:text-gold"
          >
            {l.label}
          </a>
        ))}
      </nav>

      <div className="flex flex-col items-start gap-4 md:items-end">
        <a
          href="mailto:kas@kaseybeaumont.com"
          data-testid="footer-email-link"
          className="font-serif text-lg italic text-bone transition-colors duration-300 hover:text-gold"
        >
          kas@kaseybeaumont.com
        </a>
        <button
          data-testid="back-to-top-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="inline-flex items-center gap-2 rounded-full border border-bone/20 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/70 transition-colors duration-300 hover:border-gold hover:text-gold"
        >
          Back to top <ArrowUp size={13} />
        </button>
      </div>
    </div>

    <div className="mx-auto mt-12 flex max-w-7xl flex-col gap-2 border-t border-bone/10 px-5 pt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-bone/35 sm:flex-row sm:justify-between sm:px-8">
      <span>© 2026 Kasey Beaumont Culinary</span>
      <span>kaseybeaumont.com</span>
    </div>
  </footer>
);
